import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as hoursFromDto } from '../../../models/adapters/HoursAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchHours, FetchHoursPayload, hoursFetched, hoursFetchFailed, HoursFetchResponsePayload } from '../../actions/setting/fetchHours';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createHoursFetchtResponseAction(placeUuid: string, response): Action<HoursFetchResponsePayload> {
  const { error, hoursDto } = response;
  const timestamp = moment();
  if (!error) {
    return hoursFetched({ hours: hoursFromDto(hoursDto), timestamp });
  }
  return hoursFetchFailed({ placeUuid, timestamp });
}

function* fetchHoursSaga({ payload }: Action<FetchHoursPayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getHours, token, { placeUuid });
  const action = createHoursFetchtResponseAction(placeUuid, response);
  yield put(action);
}

export default function* watchFetchHoursSaga() {
  yield takeLeading(fetchHours, fetchHoursSaga);
}
